import React from "react";

export interface Props {
  children: React.ReactNode | React.ReactNode[];
}

const IncCardHeader: React.FC<Props> = props => <div className="inc-card-header">{props.children}</div>;

export default IncCardHeader;
